/**
 * Loads team logo as a data-URL usable by jsPDF.addImage.
 * Returns { dataUrl, format } or null if no logo or load failed.
 */
export async function loadLogoForPdf(team) {
  if (!team?.logo_url) return null;
  try {
    const res = await fetch(team.logo_url, { credentials: "include" });
    if (!res.ok) return null;
    const blob = await res.blob();
    const ext = (blob.type || "").split("/")[1]?.toUpperCase() || "PNG";
    const format = ext === "JPEG" || ext === "JPG" ? "JPEG" : "PNG";
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    return { dataUrl, format };
  } catch (err) {
    console.warn("Logo PDF load failed:", err);
    return null;
  }
}
